module.exports = __webpack_public_path__ + "img/hubspot.dd2cd6a3.png";